const type = 'SET_PARAM_MENU_FIXED';

const setParamMenuFixed = (payload) => ({
  type,
  payload,
});

export { type };
export default setParamMenuFixed;
